import { connect } from 'react-redux'
import Category from './Category'

export default connect(store => ({
	icons: store.localstore.icons,
	isHorizontal: store.icoSettings.isHorizontal
}))(Category)
